import React from 'react';
import { BsPeople, BsCalendar } from 'react-icons/bs';
import { AiOutlineClockCircle } from 'react-icons/ai';
import styled from 'styled-components';

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 200px 400px;
  padding-left: 1rem;
`;

const TablebookingStats = ({
  guestName = 'Temp Name',
  guests = '02 Guests',
  date = '08 October 2020',
  time = '12:30PM',
}) => (
  <GridContainer>
    <p className="has-text-weight-semibold is-size-8 mt-1">{guestName}</p>
    <div className="is-flex is-justify-content-space-between">
      <span className="is-flex">
        <BsPeople size={18} />
        &nbsp;
        {guests}
      </span>
      <span className="is-flex">
        <BsCalendar size={18} />
        &nbsp;
        {date}
      </span>
      <span className="is-flex">
        <AiOutlineClockCircle size={18} />
        &nbsp;
        {time}
      </span>
    </div>
  </GridContainer>
);

export default TablebookingStats;
